"use strict";
exports.__esModule = true;
var reserved_words_1 = require("./reserved-words");
var validateDeveloperName = function (value, isAdmin, fieldName) {
    if (fieldName === void 0) { fieldName = 'Имя разработчика'; }
    return isAdmin ? '' : reserved_words_1.validateReservedWords(value.toLowerCase(), fieldName);
};
exports["default"] = validateDeveloperName;
